import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCollection } from '../../firebase/firestore';
import './Partners.css';

const Partners = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      setLoading(true);
      const { db } = await import('../../firebase/config');

      if (!db) {
        console.warn('Firestore not configured');
        setLoading(false);
        return;
      }

      const data = await getCollection('partners');
      // Filter only active partners and sort by order
      const activePartners = data
        .filter(p => p.active !== false)
        .sort((a, b) => (a.order || 0) - (b.order || 0));

      setPartners(activePartners);
    } catch (error) {
      console.error('Error fetching partners:', error);
      setPartners([]);
    } finally {
      setLoading(false);
    }
  };

  // Show loading state
  if (loading) {
    return (
      <section className="partners-section section">
        <div className="container">
          <div className="section-title" style={{ textAlign: 'center', marginBottom: '2rem' }} data-aos="fade-up">
            <h3 className="section-title-gradient">
              Trusted By
            </h3>
          </div>
          <div style={{ textAlign: 'center', padding: '3rem 0', color: 'var(--text-secondary)' }}>
            <div className="loading-spinner" style={{ margin: '0 auto' }}></div>
            <p style={{ marginTop: '1rem' }}>Loading partners...</p>
          </div>
        </div>
      </section>
    );
  }

  // Hide section if no active partners
  if (partners.length === 0) {
    return null;
  }

  return (
    <section className="partners-section section">
      <div className="container">
        <div className="section-title" style={{ textAlign: 'center', marginBottom: '3rem' }} data-aos="fade-up">
          <br></br>  <h3 className="section-title-gradient">
            Trusted By
          </h3>
        </div>

        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div
              key={partner.id || index}
              className="partner-card"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="partner-image"
                onError={(e) => {
                  console.error('Image failed to load:', partner.logo);
                  e.target.style.display = 'none';
                }}
              />
              <div className="partner-overlay">
                <div className="partner-info">
                  <h3>{partner.name}</h3>
                  <p className="partner-position">{partner.position}, {partner.company}</p>
                  <p className="partner-testimonial">"{partner.testimonial}"</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
